class Bonus {

	constructor(_form, _validate) {
		this.form = _form;
		this.validate = _validate;
		this.initialize();
	}

	initialize() {
		console.log('bonus init');
	}

	result(response) {
		var _id = this.form.attr('id');

		// добавить карту
		if (_id === 'addCardForm') {
			let _card = $('#addCardForm [name="card"]').val();
			$('#authCardContact [name="card"]').val(_card);
			$('#authCardConfirm [name="card"]').val(_card);
			$('#selectCardConfirm [name="card"]').val(_card);
			$('#checkCardConfirm [name="card"]').val(_card);

			if (response['RESULT'] === 'OK') {
				// карта есть, карта активна

				$('#addCardForm').addClass('hidden');
				$('#selectCardConfirm').removeClass('hidden');

				let _form = $('#selectCardConfirm');
				let _block = _form.parent();
				let _contact = response['CONTACT'];

				if (_contact['PHONE'] > '') {
					_block.find('.card-phone-if').removeClass('hidden');
					_block.find('.card-phone').text(_contact['PHONE']);
				} else {
					_block.find('.card-phone-if').addClass('hidden');
				}

				if (_contact['EMAIL'] > '') {
					_block.find('.card-email-if').removeClass('hidden');
					_block.find('.card-email').text(_contact['EMAIL']);
				} else {
					_block.find('.card-email-if').addClass('hidden');
				}

				if (_contact['EMAIL'] > '' || _contact['PHONE'] > '') {
					_block.find('.card-contact-no').addClass('hidden');
					_block.find('.card-contact-yes').removeClass('hidden');
				} else {
					_block.find('.card-contact-no').removeClass('hidden');
					_block.find('.card-contact-yes').addClass('hidden');
				}

				_form.find('.card-confirm').off('click').on('click', function () {
					_form.find('[name="type"]').val($(this).data('confirm'));
					_form.submit();
				});

			} else {
				// ошибка при вводе карты

				let validateErrors = {};
				if (response['FIELD'] === 'CONTACT') {
					// карта не активирована
					$('#addCardForm').addClass('hidden');
					$('#authCardContact').removeClass('hidden');

					validateErrors = false;
				} else if (response['FIELD'] === 'PINCODE') {
					validateErrors['pinCode'] = 'Пин-код неверен';
				} else if (response['FIELD'] === 'NEW_CARD') {
					// карта новая, нельзя активировать
					validateErrors['card'] = window.errorText['inactiveCard'];
				} else {
					validateErrors['card'] = 'Карта не найдена';
				}

				if (validateErrors) {
					this.validate.showErrors(validateErrors);
				}
			}
		}

		// активируем карту, заполнена форма с контактными данными
		if (_id === 'authCardContact') {
			if (response['RESULT'] === 'SEND') {
				// высланы коды подтверждения
				$('#authCardContact').addClass('hidden');
				$('#authCardConfirm').removeClass('hidden');
				$('#authCardConfirm .check-phone').text($('#cardContactPhone').val());
				$('#authCardConfirm .check-email').text($('#cardContactEmail').val()); // ввести новые контактные данные

				$('.reSetProps').off('click').on('click', function () {
					$('#authCardConfirm').addClass('hidden');
					$('#authCardContact').removeClass('hidden');
					return false;
				});
			}
		}

		// подтверждаем активацию карты
		if (_id === 'authCardConfirm') {
			if (response['RESULT'] === 'ERROR') {

				let validateErrors = {};
				if ($.inArray('phone', response['ERROR']) !== -1) {
					validateErrors['cardConfirmPhone'] = 'Неверный код подтверждения';
				}
				if ($.inArray('email', response['ERROR']) !== -1) {
					validateErrors['cardConfirmEmail'] = 'Неверный код подтверждения';
				}

				this.validate.showErrors(validateErrors);

			} else {
				// найден контакт, запустим процесс отправки формы ввода пин-кода заново
				$('#authCardConfirm').addClass('hidden');
				$('#addCardForm').removeClass('hidden').submit();
			}
		}

		// карта активирована, выбираем способ ее подтвердить
		if (_id === 'selectCardConfirm') {
			let _block = $('#checkCardConfirm');
			let _type = $('#selectCardConfirm [name="type"]').val();
			_block.find('[name="type"]').val(_type);
			_block.find('.card-' + _type + '-send').removeClass('hidden');

			$('#selectCardConfirm').addClass('hidden');
			_block.removeClass('hidden');
		}

		// карта активирована, потверждаем
		if (_id === 'checkCardConfirm') {
			if (response['RESULT'] === 'OK') {
				$('#checkCardConfirm').addClass('hidden');
				$('#successAddCard').removeClass('hidden');

				setTimeout(this.reloadPage, 3000);
			} else {
				let validateErrors = {};
				validateErrors['code'] = 'Неверный код подтверждения';

				this.validate.showErrors(validateErrors);
			}
		}

		// карта удалена
		if (_id === 'deleteCardForm') {
			this.reloadPage();
		}

		// отредактированы данные по карте
		if (_id === 'changeContact') {
			if (response['RESULT'] === 'OK') {
				$('#changeContact').addClass('hidden');
				$('#changeContactSuccess').removeClass('hidden');
				setTimeout(this.reloadPage, 3000);
			} else {
				alert(response['MESSAGE']);
			}
		}

		// выпустить новую карту
		if (_id === 'newCardForm') {
			if (response['RESULT'] === 'find') {

				// нашли карту по телефону \ емейлу
				var _firstCard = response['CARD'][0];
				$('#addCard [name="card"]').val(_firstCard);
				$('#addCard [name="pinCode"]').val('');

				$('#newCardForm').addClass('hidden');
				$('#newCardFind').removeClass('hidden');

				let _mess = '<p>По введенным контактным данным мы нашли Вашу карту: <b>№' + _firstCard + '</b><br />' +
					'<a id="addCardOpen" href="#"">Привяжите ее к своему аккаунту</a></p>';
				if (response['CARD'].length > 1) {
					_mess += '<br />Найдено несколько карт: ' + response['CARD'].join(', ') + '.<br /> Чтобы объединить карты и бонусы на них, ' + window.helpText;
				}

				$('#newCardFind').find('.popup__content').html(_mess);

				$('#addCardOpen').on('click', function () {
					$('#addCardLink').click();
					return false;
				});

			} else {
				// карту не нашли, надо проверить телефон + емейл
				$('#newCardForm').addClass('hidden');
				$('#newCardCheck').removeClass('hidden');
				$('#newCardCheck').find('.check-phone').text(response['PROPS']['PHONE']);
				$('#newCardCheck').find('.check-email').text(response['PROPS']['EMAIL']);

				$('#newCardCheck #reSetProps').off('click').on('click', function () {
					$('#newCardForm').removeClass('hidden');
					$('#newCardCheck').addClass('hidden');

					return false;
				});
			}
		}

		// подтвердить данные для выпуска новой карты
		if (_id === 'newCardCheck') {
			if (response['RESULT'] === 'OK') {
				// все верно, карта создана и привязана

				$('#newCardFind .popup__title').html('Карта создана!');
				$('#newCardFind .popup__content').html('Ваша карта - <b>№' + response['CARD'] + '</b>.<br /><br />Страница перезагрузится через 3 секунды.');

				$('#newCardCheck').addClass('hidden');
				$('#newCardFind').removeClass('hidden');

				setTimeout(this.reloadPage, 3000);

			} else {

				let _validateErrors = {};
				if ($.inArray('phone', response['ERROR']) !== -1) {
					_validateErrors['phone'] = 'Неверный код подтверждения';
				}
				if ($.inArray('email', response['ERROR']) !== -1) {
					_validateErrors['email'] = 'Неверный код подтверждения';
				}
				this.validate.showErrors(_validateErrors);

				if (response['MESSAGE'] > '') {
					$('#reSetProps').click();
					alert(response['MESSAGE']);
				}
			}
		}

		// авторизация: по номеру карты
		if (_id === 'authCardForm') {
			var _card = $('#authCardForm [name="cardNumber"]').val();

			$('#authCardEmail [name="card"]').val(_card);
			$('#authCardContact [name="card"]').val(_card);
			$('#authCardConfirm [name="card"]').val(_card);

			if (response['RELOAD'] === 'Y') {
				this.reloadPage();
			} else if (response['RESULT'] === 'ERROR' && response['FIELD'] === 'CONTACT') {
				$('#authCard').find('form').addClass('hidden');
				$('#authCardContact').removeClass('hidden');
			} else if (response['RESULT'] === 'NOT_EMAIL') {
				$('#authCard').find('form').addClass('hidden');
				$('#authCardEmail').removeClass('hidden');
			} else if (response['RESULT'] === 'ERROR') {
				let _validateErrors = {};

				if (response['FIELD'] === 'PINCODE') {
					_validateErrors['pinCode'] = 'Пин-код неверен';
				} else if (response['FIELD'] === 'NEW_CARD') {
					_validateErrors['cardNumber'] = 'Ваша карта не активна';
				} else {
					_validateErrors['cardNumber'] = 'Карта не найдена';
				}

				this.validate.showErrors(_validateErrors);
			}
		}

		// авторизация: в Контакте карты не указан емейл
		if (_id === 'authCardEmail') {
			if (response['RELOAD']) {
				this.reloadPage();
			} else {
				if (response['FIELD'] === 'EXIST') {
					$('#cardEmailPassBlock').removeClass('hidden');
				} else if (response['FIELD'] === 'PASS') {
					let _validateErrors = {
						cardEmailPass : 'Пароль неверен'
					};
					this.validate.showErrors(_validateErrors);
				}
			}
		}

		// авторизация: не активирована карта
		if (_id === 'authCardContact') {
			if (response['RESULT'] === 'SEND') {
				// высланы коды подтверждения
				$('#authCard').find('form').addClass('hidden');
				$('#authCardConfirm').removeClass('hidden');

				$('#authCardConfirm').find('.check-phone').text($('#cardContactPhone').val());
				$('#authCardConfirm').find('.check-email').text($('#cardContactEmail').val());
			}
		}

		// авторизация: подтверждение владения
		if (_id === 'authCardConfirm') {
			if (response['RESULT'] === 'ERROR') {
				let _validateErrors = {};

				if ($.inArray('phone', response['ERROR']) !== -1) {
					_validateErrors['cardConfirmPhone'] = 'Неверный код подтверждения';
				}
				if ($.inArray('email', response['ERROR']) !== -1) {
					_validateErrors['cardConfirmEmail'] = 'Неверный код подтверждения';
				}

				this.validate.showErrors(_validateErrors);
			} else {
				// найден контакт, запустим процесс отправки формы ввода пин-кода заново
				$('#authCard').find('form').addClass('hidden');
				$('#authCardForm').removeClass('hidden').submit();
			}
		}

		// регистрация: проверка емейла и телефона
		if (_id === 'registerCardForm') {

			let _validateErrors = {};
			let _error = false;

			if (!response.CHECK.phone) {
				_error = true;
				_validateErrors['phone'] = 'Неверный код подтверждения';
			}
			if (!response.CHECK.email) {
				_error = true;
				_validateErrors['email'] = 'Неверный код подтверждения';
			}

			this.validate.showErrors(_validateErrors);

			if (!_error) {
				$.magnificPopup.close();

				$('[name="regform"]').find('input[name="check"]').val('Y');
				$('[name="regform"]').submit();
			}
		}

	}

	reloadPage() {
		var _url = location.href;
		_url = _url.split('#');
		_url = _url[0];
		location.href = _url;
	}
}

new Bonus();

export {Bonus};

